import React, { FC } from "react";

import {
  useApisMembersEmployeeConditionSubmissionsLikedEmployeesIndex,
  useArray,
} from "~/hooks";

import { ReactedEmployeesModal } from "~/components/molecules";

import { ReactedEmployeeType } from "~/domains";

type PropsType = {
  employeeConditionSubmissionId: string;
  onClose: () => void;
};

export const EmployeeConditionSubmissionsLikedEmployeesModal: FC<PropsType> = ({
  employeeConditionSubmissionId,
  onClose,
}: PropsType) => {
  const { items, setItems } = useArray<ReactedEmployeeType>([]);
  const { fetchNextPage, hasNextPage, isLoading } =
    useApisMembersEmployeeConditionSubmissionsLikedEmployeesIndex({
      employeeConditionSubmissionId,
      config: {
        onSuccess: (data) => {
          setItems(
            data.pages
              .map((page) => page.employeeConditionSubmissionLikes)
              .flat(),
          );
        },
      },
    });
  return (
    <ReactedEmployeesModal
      headerTitle="いいねしたユーザー"
      onClose={onClose}
      reactedEmployees={items}
      nextFetchFunction={fetchNextPage}
      hasMore={hasNextPage}
      isLoading={isLoading}
    />
  );
};
